import React, { useEffect } from "react";

interface IMainView {
  children: React.ReactNode;
  title?: string;
  backgroundClassName?: string;
}

const MainView: React.FC<IMainView> = ({
  children,
  title,
  backgroundClassName,
}) => {
  useEffect(() => {
    try {
      const bodyElement = document.body;
      if (bodyElement && backgroundClassName) {
        const backgroundClassNames = backgroundClassName.split(" ");
        bodyElement.classList.add(...backgroundClassNames);
      }

      // const prefersDarkMode = window.matchMedia(
      //   "(prefers-color-scheme: dark)"
      // ).matches;
      // console.log(prefersDarkMode);

      return () => {
        if (bodyElement && backgroundClassName) {
          const backgroundClassNames = backgroundClassName.split(" ");
          bodyElement.classList.remove(...backgroundClassNames);
        }
      };
    } catch (error) {
      console.log("error", error);
    }
  }, [backgroundClassName]);

  useEffect(() => {
    document.title = title ? `${title} | Clevast ` : "Clevast"
  }, [title]);

  return (
    <div className="text-black333 dark:text-white80 w-full h-full">
      {children}
    </div>
  );
};

export default MainView;
